import styled, { css } from 'styled-components';

export const StandingWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${props => !props.isFootballSectionWrapper && css`
    border-bottom: 1px solid ${props.theme.colors.gray};
  `}
  ${props => props.isFootballSectionWrapper && css`
    border-left: 1px solid ${props.theme.colors.gray};
    padding-left: 15px;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  ${props => !props.isFootballSectionWrapper && css`
    border-top: 1px solid ${props.theme.colors.gray};
  `};
  margin: 0px 0px 10px 0px;
  padding: 10px 0;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TablesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const GradientWrapper = styled.div`
  /* position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 96%, rgba(255,255,255,1) 100%); !* FF3.6-15 *!
  background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 96%,rgba(255,255,255,1) 100%); !* Chrome10-25,Safari5.1-6 *!
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 96%,rgba(255,255,255,1) 100%); !* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ *!
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); !* IE6-9 *! */
`;



// WEBPACK FOOTER //
// ./src/containers/StandingDashedWidget/styles.js